<template>
  <g clip-path="url(#clip0_4751_1228)">
    <path
      d="M3 1.5C3 1.91421 3.33579 2.25 3.75 2.25H8.25C8.66421 2.25 9 1.91421 9 1.5V0.75H10.5C10.9142 0.75 11.25 1.08579 11.25 1.5V11.25C11.25 11.6642 10.9142 12 10.5 12H1.5C1.08579 12 0.75 11.6642 0.75 11.25V1.5C0.75 1.08579 1.08579 0.75 1.5 0.75H3V1.5ZM8.27246 5.22754C8.05279 5.00787 7.69721 5.00787 7.47754 5.22754L5.25 7.45508L4.52246 6.72754L4.43457 6.65527C4.21623 6.51105 3.91978 6.5353 3.72754 6.72754C3.5353 6.91978 3.51105 7.21623 3.65527 7.43457L3.72754 7.52246L4.85254 8.64746C5.07221 8.86713 5.42779 8.86713 5.64746 8.64746L8.27246 6.02246C8.49213 5.80279 8.49213 5.44721 8.27246 5.22754ZM7.5 0C7.91421 4.83191e-08 8.25 0.335786 8.25 0.75C8.25 1.16421 7.91421 1.5 7.5 1.5H4.5C4.08579 1.5 3.75 1.16421 3.75 0.75C3.75 0.335786 4.08579 1.20798e-08 4.5 0H7.5Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_4751_1228">
      <rect width="12" height="12" fill="currentColor" />
    </clipPath>
  </defs>
</template>
